import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddress = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.778 5.556V2H17v3.556L18.778 10v1.778h-.89V18h-1.777v-6.222h-5.333V18h-8.89v-6.222H1V10l1.778-4.444Zm3.555-.89a.89.89 0 1 0-1.778.001.89.89 0 0 0 1.778 0Zm1.778-.888a.89.89 0 1 1 0 1.778.89.89 0 0 1 0-1.778ZM9 16.222v-4.444H3.667v4.444H9Z",
		fill: "var(--main-color)"
	})
});
export { SvgAddress as ReactComponent };
